const ORDER_KEY = 'siq_live_order';

export function normalizeBarcode(value) {
  const digits = String(value || '').replace(/\D/g, '');
  return digits || null;
}

export function loadLiveOrder() {
  try {
    const parsed = JSON.parse(localStorage.getItem(ORDER_KEY) || '[]');
    return Array.isArray(parsed) ? parsed.filter(line => line?.barcode && line?.offers) : [];
  } catch {
    return [];
  }
}

export function saveLiveOrder(lines) {
  localStorage.setItem(ORDER_KEY, JSON.stringify(lines));
  window.dispatchEvent(new CustomEvent('shopkeeperiq:order-changed'));
}

export function successfulOffers(comparison) {
  return (comparison?.suppliers || []).filter(result => result?.status === 'ok' && result.product);
}

export function comparisonToLine(comparison, existingQuantity = 1) {
  const successful = successfulOffers(comparison);
  if (!successful.length) return null;
  const preferred = successful.find(result => result.product.stockStatus !== 'outOfStock') || successful[0];
  const comparable = comparison.cheapest?.packsComparable === true;
  const offers = Object.fromEntries((comparison.suppliers || []).map(result => [result.supplier, {
    status: result.status,
    message: result.message || '',
    ...(result.product ? {
      name: result.product.name,
      sku: result.product.sku || '',
      packSize: result.product.packSize || '',
      price: Number(result.product.casePriceExVat),
      stockStatus: result.product.stockStatus || 'unknown',
      productUrl: result.product.productUrl || '',
      basketAddSupported: result.product.basketAddSupported !== false,
    } : {}),
  }]));
  return {
    barcode: comparison.barcode,
    name: preferred.product.name,
    size: preferred.product.packSize || 'Pack size unavailable',
    qty: Math.max(1, Number(existingQuantity) || 1),
    offers,
    comparable,
    cheapest: comparison.cheapest || null,
    updatedAt: comparison.completedAt || new Date().toISOString(),
  };
}

export function bestOffer(line) {
  const available = Object.entries(line?.offers || {})
    .filter(([, offer]) => offer?.status === 'ok' && offer.stockStatus !== 'outOfStock' && Number.isFinite(Number(offer.price)))
    .map(([supplier, offer]) => ({ supplier, ...offer }));
  if (!available.length) return null;
  if (line?.comparable === false) return available[0];
  return available.sort((left, right) => left.price - right.price)[0];
}

export function orderLineToCompareProduct(line) {
  const bestway = line.offers?.Bestway || {};
  const booker = line.offers?.Booker || {};
  const parfetts = line.offers?.Parfetts || {};
  const bwStock = bestway.status === 'ok' && bestway.stockStatus !== 'outOfStock';
  const bkStock = booker.status === 'ok' && booker.stockStatus !== 'outOfStock';
  const pfStock = parfetts.status === 'ok' && parfetts.stockStatus !== 'outOfStock';
  return {
    name: line.name,
    size: line.size,
    qty: Math.max(1, Number(line.qty) || 1),
    cat: 'Uncategorised',
    bwCost: Number(bestway.price) || 0,
    bkCost: Number(booker.price) || 0,
    pfCost: Number(parfetts.price) || 0,
    bwStock,
    bkStock,
    pfStock,
    bwLow: bestway.stockStatus === 'lowStock',
    bkLow: booker.stockStatus === 'lowStock',
    pfLow: parfetts.stockStatus === 'lowStock',
    bwSku: bestway.sku || '—',
    bkSku: booker.sku || '—',
    pfSku: parfetts.sku || '—',
    exclusive: null,
    pmp: false,
    packMismatch: line.comparable === false,
    barcode: line.barcode,
  };
}
